/* istanbul ignore file */

import { addressEdit, portfolioTieredContinue, roundUpsInterstitialContinue } from '../../redirects'
import { mapRequirementToRoute } from '../../requirementsMapping'
import { FlowEntry, FlowRoute } from '../../types'
import { finishOnboarding, redirectAfterBankLinkSuccess } from './redirects'

export const investOnboarding: FlowEntry[] = [
  {
    page: FlowRoute.InvestInterstitial,
    actions: [
      { name: 'continue', goTo: mapRequirementToRoute },
      { name: 'skip', goTo: () => FlowRoute.RecurringInvestment },
    ],
    isFirstPage: true,
  },
  {
    page: FlowRoute.DateOfBirth,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      { name: 'continue', goTo: mapRequirementToRoute },
      {
        name: 'choose',
        goTo: () => FlowRoute.AddressSuggestion,
      },
      {
        name: 'more_info',
        goTo: () => FlowRoute.AddressInvalid,
      },
    ],
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.SSN,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.EmploymentStatus,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.InvestmentGoal,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.FinancialEducation,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.NetWorth,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.AnnualIncome,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.KidsInvesting,
    actions: [{ name: 'continue', goTo: () => FlowRoute.PreviewPortfolio }],
  },
  {
    page: FlowRoute.SuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_questions',
        goTo: () => FlowRoute.PreviewPortfolio,
      },
    ],
  },
  {
    page: FlowRoute.PreviewPortfolio,
    actions: [
      { name: 'continue', goTo: portfolioTieredContinue },
      { name: 'about_portfolio', goTo: () => FlowRoute.AboutPortfolio },
    ],
  },
  {
    page: FlowRoute.AboutPortfolio,
    actions: [{ name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.PreviewPortfolio }],
  },
  {
    page: FlowRoute.RoundUpsInterstitial,
    actions: [
      {
        name: 'continue',
        goTo: roundUpsInterstitialContinue,
      },
      { name: 'skip', goTo: () => FlowRoute.RecurringInvestment },
    ],
  },
  {
    page: FlowRoute.RoundUpsSetup,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RoundUpsFunding },
      { name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.RoundUpsInterstitial },
      { name: 'skip', goTo: () => FlowRoute.RecurringInvestment },
    ],
  },
  {
    page: FlowRoute.RoundUpsFunding,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RoundUpsPast },
      { name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.RoundUpsSetup },
    ],
  },
  {
    page: FlowRoute.RoundUpsPast,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RecurringInvestment },
      { name: 'goBack', goTo: () => FlowRoute.RoundUpsFunding },
    ],
  },
  {
    page: FlowRoute.OneTimeInvestment,
    actions: [
      { name: 'continue', goTo: finishOnboarding },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'product-onboarding', goTo: finishOnboarding },
    ],
  },
  {
    page: FlowRoute.RecurringInvestment,
    actions: [
      { name: 'one-time', goTo: () => FlowRoute.OneTimeInvestment },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'continue', goTo: finishOnboarding },
      { name: 'product-onboarding', goTo: finishOnboarding },
    ],
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'skip', goTo: finishOnboarding },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      { name: 'skip', goTo: finishOnboarding },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [{ name: 'continue', goTo: redirectAfterBankLinkSuccess }],
  },
  {
    page: FlowRoute.AddressInvalid,
    actions: [
      {
        name: 'continue',
        goTo: addressEdit,
      },
    ],
  },
  {
    page: FlowRoute.AddressSuggestion,
    actions: [
      {
        name: 'continue',
        goTo: mapRequirementToRoute,
      },
      {
        name: 'update',
        goTo: addressEdit,
      },
    ],
  },
]
